module.exports = __webpack_public_path__ + "img/plus-black.29312f01.svg";